import { useEffect } from 'react';

import { Redirect } from 'expo-router';
import { useIntl } from 'react-intl';

import { CardModal } from 'components/card-modal';
import { useAfterInteractions } from 'hooks/use-after-interactions';
import { LoyaltyHistory } from 'pages/loyalty/loyalty-history-modal';
import { HistorySkeleton } from 'pages/loyalty/loyalty-history-modal/components/history-skeleton';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLoyaltyContext } from 'state/loyalty';
import { routes } from 'utils/routing';

export default function LoyaltyHistoryModal() {
  const { formatMessage } = useIntl();
  const { refetchLoyaltyUser } = useLoyaltyContext();
  const enableLoyaltyProfile = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_PROFILE);
  const showContent = useAfterInteractions();

  useEffect(() => {
    refetchLoyaltyUser();
  }, [refetchLoyaltyUser]);

  if (!enableLoyaltyProfile) {
    // Redirects to the History tab
    return <Redirect href={routes.rewardsHistory} />;
  }

  return (
    <CardModal
      alwaysShowHeader
      headerText={formatMessage({ id: 'historyTitle', defaultMessage: 'History' })}
    >
      {showContent ? <LoyaltyHistory /> : <HistorySkeleton />}
    </CardModal>
  );
}
